import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { device } from "../device";
import ContentWrapper from "./ContentWrapper";
import AwfireLogoSrc from "../images/awfire_logo.png";

const HeaderContainer = styled.div`
  position: fixed;
  top: ${(props) => (props.showHeader ? "0px" : "-200px")};
  z-index: 99;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  transition: top 300ms;
`;

const HeaderContentWrapper = styled(ContentWrapper)`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  column-gap: 150px;

  @media ${device.mobileS} {
    justify-content: center;
  }

  @media ${device.tablet} {
    justify-content: space-between;
  }
`;

const Awfire = styled.div`
  text-align: center;
`;

const AwfireLogo = styled.img`
  width: 80px;
  height: 80px;
  display: inline-block;
  vertical-align: -25px;

  @media ${device.mobileL} {
    margin: 5px 15px 10px 0;
  }
`;

const HeaderTitle = styled.h1`
  /* font-family: 'Montserrat', sans-serif; */
  /* font-weight: 700; */
  font-size: 2.3em;
  display: inline-block;
  color: #e22;
`;

const Header = () => {
  const [showHeader, setShowHeader] = useState(true);

  const handleScroll = (prevPos) => {
    setShowHeader(window.scrollY < 200);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showHeader]);

  return (
    <HeaderContainer showHeader={showHeader}>
      <HeaderContentWrapper paddingTopBot="10px">
        <Awfire>
          <AwfireLogo src={AwfireLogoSrc} />
          <HeaderTitle>AWFire Protection</HeaderTitle>
        </Awfire>
      </HeaderContentWrapper>
    </HeaderContainer>
  );
};

export default Header;
